import Weather from "./Weather";
import Footer from "./Footer";
import "./App.css";

export default function App() {
  return (
    <div className="weather-app">
      <Weather />
      <Footer />
    </div>
  );
}
